import { useOrganization } from "@clerk/vue";
import { computed } from "vue";
import { useAccount } from "./useAccount";

type Role = "admin" | "manager" | "employee";

export function useRoles() {
  const account = useAccount();
  const { membership } = useOrganization();
  // Admin status comes from the app's own database (is_admin flag), NOT Clerk metadata
  const isAdmin = computed(
    () => account.state.value?.employee?.isAdmin === true,
  );
  // Story 4.2: Dynamic manager detection - true if employee has direct reports
  const hasDirectReports = computed(
    () => account.state.value?.employee?.hasDirectReports ?? false,
  );
  return {
    role: computed<Role>(() => {
      if (isAdmin.value) return "admin";
      if (hasDirectReports.value) return "manager";
      return "employee";
    }),
    hasDirectReports,
    isAdmin,
    // Story 4.2: Manager capability is now derived from having direct reports OR being admin
    isManager: computed(() => hasDirectReports.value || isAdmin.value),
    isEmployee: computed(() => !isAdmin.value && !hasDirectReports.value),
    canManage: computed(() => hasDirectReports.value || isAdmin.value),
    canAdmin: isAdmin,
    isClerkAdmin: computed(() => membership.value?.role === "org:admin"),
  };
}
